import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getEnums } from '../../../actions/common'

// import styles
import './index.scss'

import HelpText from '../HelpText'
import { translation } from '../../../utils/helpers'

import Panel from '../../elements/panel'
import Grid from '../../elements/grid'
import Check from '../../elements/check'

class NotificationCopy extends Component {

  constructor (props) {
    super(props)
    this.onCheck = this.onCheck.bind(this)
  }

  componentWillReceiveProps (newProps) {
    if (newProps.notificationEventType === undefined) {
      this.props.getEnums()
    }
  }
  renderNotifications () {
    if (this.props.notificationEventType === undefined || this.props.notificationEventType === null || this.props.notificationEventType.length === 0) {
      return
    }
    // if (!hasPermission(this.props.auth, 0, false)) return null
    let user = this.props.user

    const NotificationEventTypeList = (val, key) => {
      if (val.Id >= 100) {
        let helptext = ''
        switch (val.Id) {
          case 100:
            helptext = '2169'
            break
          case 102:
            helptext = '15023' // '2170'
            break
          case 103:
            helptext = '2171'
            break
          case 104:
            helptext = '15024' // '2198'
            break
          case 105:
            helptext = '2172'
            break
          case 106:
            helptext = '2173'
            break
          case 108:
            helptext = '15022'
            break
        }

        let notification = []
        if (user.NotificationSettings !== undefined) {
          notification = user.NotificationSettings.filter(x => x.NotificationEvent === val.Id)
        }
        let Email = false
        let Sms = false
        if (notification.length > 0) {
          Email = notification[0].Email
          Sms = notification[0].Sms
        }

        return (
          <Grid cols={[ (this.props.SMS ? 2 : 3) ]} spacing={1} key={key}>
            <span>{translation(val.key)} <HelpText text={translation(helptext)} /></span>

            <Check name='Email' value={val.Id} checked={Email} onChange={this.onCheck} disabled={user.Email === null || user.Email.length === 0} simple />

            {this.props.SMS && (
              <Check name='Sms' value={val.Id} checked={Sms} onChange={this.onCheck} disabled={user.Phone === null || user.Phone.length === 0} simple />
            )}
          </Grid>
        )
      } else {
        return null
      }
    }
    var notificationEventType = []
    var vals = Object.values(this.props.notificationEventType)
    var keys = Object.keys(this.props.notificationEventType)
    for (var i = 0; i < keys.length; i++) {
      notificationEventType.push({ Id: parseInt(keys[i]), key: vals[i] })
    }
    var title = user.Department !== 0 ? '13461' : '14947'
    return (
      <Panel title={translation(title)}>
        <Grid cols={[ (this.props.SMS ? 2 : 3) ]} spacing={1}>
          <span />
          <span>{translation('1052')}</span>
          {this.props.SMS && (<span>{translation('15')}</span>)}
        </Grid>
        {notificationEventType.map(NotificationEventTypeList)}
      </Panel>
    )
  }

  onCheck (e) {
    var user = { ...this.props.user }
    // check if set
    var set = false
    var array = [...user.NotificationSettings]
    array.map(function (val, key) {
      // console.log('Checked: ', key, val)
      if (val.NotificationEvent === Number(e.target.value)) {
        set = true
        if (e.target.name === 'Sms') {
          array[key].Sms = e.target.checked
        } else if (e.target.name === 'Email') {
          array[key].Email = e.target.checked
        }
      }
    })
    // if not set - add object
    if (set === false) {
      var newItem = {}
      if (e.target.name === 'Sms') {
        newItem = {
          NotificationEvent: Number(e.target.value),
          Sms: e.target.checked,
          Email: false
        }
      } else if (e.target.name === 'Email') {
        newItem = {
          NotificationEvent: Number(e.target.value),
          Sms: false,
          Email: e.target.checked
        }
      }
      array.push(newItem)
      // if set change
    }

    this.props.SaveNotifications(array)
  }

  render () {
    return (
      <div className='notification_copy__wrapper'>
        {this.renderNotifications()}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    notificationEventType: state.common.enums_new.NotificationEventType
  }
}

export default connect(mapStateToProps, {
  getEnums
})(NotificationCopy)



// WEBPACK FOOTER //
// ./src/app/shared/components/NotificationCopy/index.js